/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Field_DateInputs */

const en_lesson_field_date = /** @type {(inputs: Lesson_Field_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const he_lesson_field_date = /** @type {(inputs: Lesson_Field_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תאריך`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Lesson_Field_DateInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_field_date = /** @type {((inputs?: Lesson_Field_DateInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Field_DateInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_field_date(inputs)
	return he_lesson_field_date(inputs)
});